import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { InactivityCountdownHttpHandlerService } from './fi-services/inactivity-countdown-http-handler.service';
import { Inject, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';

@Injectable()
export class FiHttpInactivityCountdownInterceptor implements HttpInterceptor {
    constructor(
        @Inject(InactivityCountdownHttpHandlerService)
        private inactivityCountdownHttpHandlerService: InactivityCountdownHttpHandlerService,
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        return next.handle(req).pipe(
            tap((resp: HttpResponse<any>) => {
                if (resp instanceof HttpResponse && resp.status === 200) {
                    this.inactivityCountdownHttpHandlerService.Reset();
                }
            }),
        );
    }
}
